import React from 'react';
const tomes = [{
  label: 'Tomo 1',
  color: 'rgb(15, 15, 15)',
  emoji: '🪣',
  desc: 'Fundamentos Pro'
}, {
  label: 'Tomo 2',
  color: 'rgb(20, 20, 40)',
  emoji: '💿',
  desc: 'El Arte del Pulido'
}, {
  label: 'Tomo 3',
  color: 'rgb(30, 20, 10)',
  emoji: '🪑',
  desc: 'Interiores Extremos'
}, {
  label: 'Tomo 4',
  color: 'rgb(10, 25, 10)',
  emoji: '⚗️',
  desc: 'Química y Costos'
}, {
  label: 'Tomo 5',
  color: 'rgb(40, 10, 10)',
  emoji: '💰',
  desc: 'El Negocio Cash'
}, {
  label: 'Tomo 6',
  color: 'rgb(30, 25, 5)',
  emoji: '🏆',
  desc: 'Protección y Sellado'
}];
const features = ['✅ Técnicas de pulido y sellado cerámico', '✅ 6 Tomos completos con protocolos reales', '✅ Negocio de alto ticket desde cero', '✅ Agenda llena en 30 días + 4 Bonos exclusivos'];
export function ProductShowcase() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#111111',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-252">
      <div className="mx-auto max-w-4xl text-center" data-id="element-253">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-yellow-400 border border-yellow-400/50 bg-yellow-400/5 rounded-full px-4 py-1.5" data-id="element-254">
          🏆 El sistema más completo para vivir del Detailing en Argentina
        </div>

        {/* Title */}
        <h2 className="text-4xl leading-[40px] font-black text-white m-0 mb-2" data-id="element-255">
          🚗 MEGAPACK DETAILER ARGENTINO™
        </h2>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-yellow-400 m-0 mb-4" data-id="element-256">
          EL MÉTODO PRO — SISTEMA COMPLETO
        </h3>

        {/* Description */}
        <p className="mx-auto max-w-2xl text-base leading-[24px] text-gray-300 m-0 mb-8" data-id="element-257">
          <strong className="text-white" data-id="element-258">
            6 Tomos + 4 Bonos — De Principiante a Detailer Profesional.
          </strong>
          <br data-id="element-259" />
          +300 páginas · Fundamentos Pro · El Arte del Pulido · Interiores
          Extremos · Química y Costos · El Negocio Cash · Protección y Sellado
          Cerámico. Resultados desde el primer trabajo.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-8" data-id="element-260">
          <div className="grid grid-cols-6 justify-center gap-2" data-id="element-261">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center justify-between aspect-[3/4] shadow-md border-2 border-yellow-400/40 rounded-lg overflow-hidden" style={{
            backgroundColor: tome.color
          }} data-id="element-262">
                <div className="flex-1 flex items-center justify-center" data-id="element-263">
                  <span className="text-3xl sm:text-4xl drop-shadow-lg" data-id="element-264">
                    {tome.emoji}
                  </span>
                </div>
                <div className="w-full bg-black/50 backdrop-blur-sm py-1.5 px-1 text-center" data-id="element-265">
                  <span className="block text-[10px] font-bold text-yellow-400" style={{
                textShadow: 'rgba(0,0,0,0.8) 0px 1px 3px'
              }} data-id="element-266">
                    {tome.label}
                  </span>
                  <span className="block text-[8px] sm:text-[9px] text-white/80 leading-tight mt-0.5" data-id="element-267">
                    {tome.desc}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge overlay */}
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap bg-yellow-400 text-[10px] font-black text-gray-900 rounded-full px-3 py-1 shadow-sm" data-id="element-268">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Feature Tags */}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-269">
          {features.map(feature => <span key={feature} className="bg-yellow-400/5 text-xs font-semibold text-yellow-400 border border-yellow-400/30 rounded-full px-3 py-1.5" data-id="element-270">
              {feature}
            </span>)}
        </div>
      </div>
    </section>;
}